import { Component, HostListener, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-rhillane',
  templateUrl: './rhillane.component.html',
  styleUrls: ['./rhillane.component.scss']
})
export class RhillaneComponent implements OnInit, OnDestroy {
  // Banner background images
  bannerImageUrl: string = '/assets/images/slides/V4.jpg';
  personImageUrl: string = '/assets/images/person-laptop.png';
  bgGradientUrl: string = '/assets/images/bg-gradient.png';

  // Form control variables
  currentStep = 1;
  isSubmitting: boolean = false;
  formSubmitted: boolean = false;
  submissionSuccess: boolean = false;
  submissionError: string = '';

  // FAQ control variables
  activeFaq: number | null = null;
  showAllFaqs: boolean = false;

  // Partners control variables
  currentSlide = 0;
  totalSlides = 6; // Number of unique partners
  autoSlideInterval: any;

  // Footer control variables
  currentYear = new Date().getFullYear();

  // Portfolio Properties
  portfolioFilters = [
    { label: 'Tous', value: 'all' },
    { label: 'Sites Web', value: 'website' },
    { label: 'E-commerce', value: 'ecommerce' },
    { label: 'Applications', value: 'application' },
    { label: 'Branding', value: 'branding' },
    { label: 'Design', value: 'design' }
  ];

  activeFilter: string = 'all';
  selectedPortfolio: any = null;
  hasMoreProjects: boolean = true;
  displayedProjectsCount: number = 6;

  // Portfolio Data - Copied from home-seven component
  portfolioItems = [
    {
      id: 1,
      title: 'L\'étincelle secrète',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour gîte romantique avec spa et hammam',
      brief: 'Site web moderne pour location de love room haut de gamme',
      image: 'portfolio/letincelle-secrete',
      technologies: ['WordPress', 'Divi Theme', 'PHP', 'MySQL', 'CSS3'],
      year: '2023',
      fullDescription: 'Site web professionnel pour un gîte romantique privatif de 80m² situé dans le Tarn. Le site présente une love room haut de gamme équipée d\'un spa, hammam, billard, cheminée et chambre secrète. Interface moderne avec système de réservation en ligne intégré, galerie photo, formulaire de contact et présentation des offres & services. Design élégant utilisant le thème Divi avec mise en avant des atouts du lieu et des activités touristiques régionales (Albi, Cordes-sur-Ciel, Najac).'
    },
    {
      id: 2,
      title: 'EnrFath',
      category: 'E-commerce',
      type: 'ecommerce',
      description: 'Plateforme e-commerce complète avec gestion de produits et paiement en ligne',
      brief: 'Site e-commerce moderne avec fonctionnalités avancées',
      image: 'portfolio/EnrFath',
      technologies: ['WooCommerce', 'WordPress', 'PHP', 'MySQL', 'JavaScript'],
      year: '2024',
      fullDescription: 'Plateforme e-commerce complète développée avec WooCommerce et WordPress. Le site inclut une gestion avancée des produits, un système de panier d\'achat, des options de paiement sécurisées, et une interface d\'administration intuitive pour la gestion des commandes et du stock.'
    },
    {
      id: 3,
      title: 'Jasan',
      category: 'Site Web',
      type: 'website',
      description: 'Site web professionnel',
      brief: 'Site web avec design professionnel',
      image: 'portfolio/jasan',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel avec design soigné et fonctionnalités modernes.'
    },
    {
      id: 4,
      title: 'Disway',
      category: 'E-commerce',
      type: 'ecommerce',
      description: 'Boutique en ligne moderne avec catalogue de produits étendu',
      brief: 'Site e-commerce avec design responsive et optimisé',
      image: 'portfolio/Disway',
      technologies: ['WooCommerce', 'WordPress', 'PHP', 'MySQL', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Boutique en ligne moderne développée avec WooCommerce et WordPress. Le site propose un catalogue de produits étendu, un système de recherche avancé, des filtres de produits, une gestion des avis clients, et une expérience d\'achat optimisée pour mobile et desktop.'
    },
 
    {
      id: 5,
      title: 'Bati',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour entreprise de construction',
      brief: 'Site web pour le secteur du bâtiment',
      image: 'portfolio/bati',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour entreprise de construction avec présentation des services et réalisations.'
    },
   
    {
      id: 6,
      title: 'Les Vélos au Bord de l\'Eau',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour location de vélos rétro en Champagne',
      brief: 'Site web moderne pour service de location de vélos vintage',
      image: 'portfolio/velos-champagne',
      technologies: ['WebGazelle CMS', 'PHP', 'MySQL', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour un service de location de vélos rétro en Champagne. Implanté à l\'entrée de la voie verte de la Marne (V52) à Magenta, le site présente une collection de vélos vintage du siècle dernier révisés avec soin. Interface moderne avec système de réservation en ligne intégré (Lokki.rent), galerie photo, suggestions d\'itinéraires cyclables, formulaire de contact et gestion multilingue (français/anglais). Design élégant mettant en avant le tourisme doux et la valorisation du paysage viticole champenois. Site hébergé en France avec gestion éco-responsable.'
    },
    {
      id: 7,
      title: 'Sostabib',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour professionnel de santé',
      brief: 'Site web médical professionnel',
      image: 'portfolio/sostabib',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour professionnel de santé avec interface claire et informative.'
    },



    {
      id: 10,
      title: 'AIMO - Site Vitrine',
      category: 'Site Web',
      type: 'website',
      description: 'Site vitrine responsive avec design moderne et optimisation SEO',
      brief: 'Site vitrine élégant avec présentation des services et portfolio',
      image: 'portfolio/aimo',
      technologies: ['HTML5', 'CSS3', 'JavaScript', 'WordPress'],
      year: '2024',
      fullDescription: 'Développement d\'un site vitrine moderne et responsive pour présenter les services d\'AIMO avec optimisation SEO et interface utilisateur intuitive.'
    },
    {
      id: 11,
      title: 'Cardalia',
      category: 'Site Web',
      type: 'website',
      description: 'Site web moderne et élégant',
      brief: 'Site web avec design moderne',
      image: 'portfolio/cardalia',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web moderne avec interface utilisateur élégante et expérience optimisée.'
    },
   
    {
      id: 12,
      title: 'NAD AGENCY - Identité Visuelle',
      category: 'Design',
      type: 'design',
      description: 'Création d\'une identité visuelle complète et moderne pour NAD Agency',
      brief: 'Branding complet avec logo, charte graphique et supports de communication',
      image: 'portfolio/nad',
      technologies: ['Illustrator', 'Photoshop', 'InDesign'],
      year: '2024',
      fullDescription: 'Conception d\'une identité visuelle forte pour NAD Agency incluant création du logo, charte graphique, supports de communication et déclinaisons digitales.'
    },
   
   
    {
      id: 14,
      title: 'Dr Abdelaaziz NAITNBAREK',
      category: 'Branding',
      type: 'branding',
      description: 'Création graphique pour cabinet médical avec supports de communication',
      brief: 'Design professionnel pour cabinet médical spécialisé',
      image: 'portfolio/doc',
      technologies: ['Photoshop', 'Illustrator', 'InDesign'],
      year: '2023',
      fullDescription: 'Conception de supports de communication pour le cabinet du Dr Abdelaaziz NAITNBAREK incluant cartes de visite, en-têtes de lettres et signalétique.'
    },
    {
      id: 15,
      title: 'Opando - Application Web',
      category: 'Application',
      type: 'application',
      description: 'Application web progressive avec fonctionnalités avancées',
      brief: 'PWA moderne avec interface utilisateur optimisée',
      image: 'portfolio/opando',
      technologies: ['Java', 'Spring Boot', 'Angular', 'TypeScript', 'HTML', 'CSS', 'Docker'],
      year: '2024',
      fullDescription: 'Développement d\'une application web progressive pour Opando avec fonctionnalités avancées, synchronisation offline et interface utilisateur optimisée.'
    },
    {
      id: 16,
      title: 'Zenixel - Plateforme SaaS',
      category: 'Application',
      type: 'application',
      description: 'Plateforme SaaS complète avec dashboard administrateur',
      brief: 'Solution SaaS avec interface d\'administration complète',
      image: 'portfolio/zenixel',
      technologies: ['Java', 'Spring Boot', 'Angular', 'TypeScript', 'HTML', 'CSS', 'Docker'],
      year: '2024',
      fullDescription: 'Création d\'une plateforme SaaS complète pour Zenixel avec dashboard administrateur, gestion des utilisateurs et système de facturation intégré.'
    },
    {
      id: 17,
      title: 'Tiguemi - Identité Graphique',
      category: 'Branding',
      type: 'branding',
      description: 'Création d\'identité graphique unique et mémorable',
      brief: 'Design créatif pour marque lifestyle moderne',
      image: 'portfolio/kell',
      technologies: ['Illustrator', 'Photoshop', 'After Effects'],
      year: '2023',
      fullDescription: 'Développement d\'une identité graphique complète pour Tiguemi incluant logo animé, charte graphique et déclinaisons pour supports digitaux et print.'
    },
    {
      id: 18,
      title: 'LA TOUCHE DES AMAZIGH',
      category: 'Branding',
      type: 'branding',
      description: 'Branding culturel avec respect des traditions amazighes',
      brief: 'Identité visuelle authentique inspirée de la culture amazighe',
      image: 'portfolio/touche',
      technologies: ['Illustrator', 'Photoshop', 'InDesign'],
      year: '2023',
      fullDescription: 'Création d\'une identité de marque authentique pour LA TOUCHE DES AMAZIGH en respectant les codes culturels et en modernisant l\'approche visuelle.'
    },
   
    {
      id: 21,
      title: 'Lesagum - Design Complet',
      category: 'Design',
      type: 'design',
      description: 'Identité de marque complète pour Lesagum avec design moderne et élégant',
      brief: 'Création d\'identité visuelle avec logo, charte graphique et applications',
      image: 'portfolio/Lesagumpreview',
      technologies: ['Illustrator', 'Photoshop', 'InDesign', 'Figma'],
      year: '2024',
      fullDescription: 'Développement d\'une identité de marque complète pour Lesagum incluant création du logo principal et variantes, élaboration d\'une charte graphique détaillée (couleurs, typographie, iconographie), déclinaisons pour supports digitaux (réseaux sociaux, site web, applications mobiles) et supports print (papeterie, packaging, signalétique). L\'identité visuelle reflète l\'élégance et la modernité de la marque avec une palette de couleurs soignée et une typographie distinctive.'
    },
    {
      id: 22,
      title: 'AIMO - Identité de Marque',
      category: 'Design',
      type: 'design',
      description: 'Création d\'identité visuelle professionnelle pour AIMO avec logo et charte graphique',
      brief: 'Design complet avec identité visuelle moderne et applications variées',
      image: 'portfolio/aimo',
      technologies: ['Illustrator', 'Photoshop', 'InDesign', 'After Effects'],
      year: '2024',
      fullDescription: 'Conception d\'une identité de marque complète pour AIMO incluant création du logo avec différentes variantes (horizontal, vertical, monochrome), développement d\'une charte graphique exhaustive avec palette de couleurs, typographie, règles d\'utilisation, déclinaisons pour supports digitaux (réseaux sociaux, site web, emailing) et supports print (papeterie, cartes de visite, en-têtes, présentations). L\'identité reflète le professionnalisme et l\'innovation de la marque avec un design moderne et impactant.'
    },
    {
      id: 23,
      title: 'Tiguemi - Identité Graphique',
      category: 'Design',
      type: 'design',
      description: 'Création d\'identité graphique unique et mémorable pour Tiguemi',
      brief: 'Design créatif pour marque lifestyle moderne avec logo animé',
      image: 'portfolio/Kelpreview',
      technologies: ['Illustrator', 'Photoshop', 'After Effects', 'InDesign'],
      year: '2024',
      fullDescription: 'Développement d\'une identité graphique complète et innovante pour Tiguemi incluant création du logo avec animation, élaboration d\'une charte graphique créative, déclinaisons pour supports digitaux (réseaux sociaux avec animations, site web, applications) et supports print (packaging, merchandising, signalétique). L\'identité reflète l\'esprit lifestyle et moderne de la marque avec des éléments visuels dynamiques et une approche design audacieuse. Le logo animé apporte une dimension interactive à l\'identité de marque.'
    },
    {
      id: 24,
      title: 'Click Light - Design Digital',
      category: 'Design',
      type: 'design',
      description: 'Identité visuelle digitale pour Click Light avec design moderne et lumineux',
      brief: 'Création d\'identité de marque avec focus sur l\'expérience digitale',
      image: 'portfolio/clic-lighpreview',
      technologies: ['Illustrator', 'Photoshop', 'Figma', 'After Effects'],
      year: '2024',
      fullDescription: 'Conception d\'une identité visuelle digitale complète pour Click Light incluant création du logo avec variantes adaptées aux différents contextes digitaux, développement d\'une charte graphique moderne avec palette de couleurs lumineuse et vibrante, déclinaisons optimisées pour supports digitaux (réseaux sociaux, site web responsive, applications mobiles, emailing), animations et micro-interactions pour renforcer l\'identité de marque. L\'identité reflète l\'innovation et la modernité de Click Light avec un design épuré et impactant qui met en valeur le concept de lumière et d\'illumination.'
    },
    {
      id: 20,
      title: 'Manasik Reizen',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour agence de voyages Hajj et Umrah',
      brief: 'Site web professionnel pour organisation de pèlerinages islamiques',
      image: 'portfolio/manasik',
      technologies: ['PHP', 'MySQL', 'CSS3', 'JavaScript', 'WordPress'],
      year: '2022',
      fullDescription: 'Site web professionnel pour Manasik Reizen, agence de voyages spécialisée dans l\'organisation de pèlerinages Hajj et Umrah depuis plus de 20 ans. Basée à Amsterdam, l\'agence a été désignée comme guide de premier plan pour le Hajj 2024 lors de l\'expo Hajj à Jeddah. Le site propose une présentation complète des forfaits de pèlerinage, système de réservation en ligne, informations pratiques sur les rituels, services d\'accompagnement personnalisé avec guides expérimentés, gestion des visas et hébergements de luxe près des mosquées sacrées. Interface multilingue (néerlandais/anglais) avec chat en direct et formulaire de contact. L\'agence propose également des voyages vers Zanzibar et d\'autres destinations musulmanes.'
    }
  ];

  // Form data object with all required fields
  formData = {
    name: '',
    email: '',
    company: '',
    employeeCount: '',
    countryCode: '+33',
    phone: '',
    services: {
      webSite: false,
      seo: false,
      advertising: false,
      socialMedia: false,
      design: false,
      photo: false,
      copywriting: false,
      global: false,
      development: false
    },
    budget: '',
    subject: '',
    details: '',
    acceptTerms: false
  };

  // Partners data
  partners = [
    {
      name: 'Ahrefs',
      logo: 'assets/images/partners/ahrefs.png',
      alt: 'Ahrefs'
    },
    {
      name: 'PrestaShop',
      logo: 'assets/images/partners/prestashop.png',
      alt: 'PrestaShop'
    },
    {
      name: 'WordPress',
      logo: 'assets/images/partners/wordpress.png',
      alt: 'WordPress'
    },
    {
      name: 'AWS',
      logo: 'assets/images/partners/aws.png',
      alt: 'AWS Partner Network'
    },
    {
      name: 'Meta',
      logo: 'assets/images/partners/meta.png',
      alt: 'Meta Business Partner'
    },
    {
      name: 'Google Cloud',
      logo: 'assets/images/partners/google-cloud.png',
      alt: 'Google Cloud Partner'
    }
  ];

  socialMedia = [
    {
      iconClass: "fb",
      icon: "icofont icofont-social-facebook",
      url: "https://www.facebook.com/people/Digital-alchemy/61565618420833",
      name: "Facebook"
    },
    {
      iconClass: "be",
      icon: "icofont icofont-social-behance",
      url: "https://www.behance.net/digitalalchemy2",
      name: "Behance"
    },
    {
      iconClass: "in",
      icon: "icofont icofont-social-linkedin",
      url: "https://www.linkedin.com/company/digital-alchemy-ma/",
      name: "LinkedIn"
    },
    {
      iconClass: "yt",
      icon: "icofont icofont-social-youtube",
      url: "https://www.youtube.com/@Digital_Alchemy_ma",
      name: "YouTube"
    },
    {
      iconClass: "ins",
      icon: "icofont icofont-social-instagram",
      url: "https://www.instagram.com/digital_alchemy_ma/",
      name: "Instagram"
    }
  ];

  // Social media links
  socialLinks = {
    linkedin: 'https://www.linkedin.com/company/digital-alchemy-ma/',
    facebook: 'https://www.facebook.com/people/Digital-alchemy/61565618420833',
    instagram: 'https://www.instagram.com/digital_alchemy_ma/',
    behance: 'https://www.behance.net/digitalalchemy2',
    youtube: 'https://www.youtube.com/@Digital_Alchemy_ma'
  };

  // Contact information
  contactInfo = {
    email: 'Digitalalchemyma@gmail.com',
    email2: 'moaadeljallab@gmail.com',
    phone1: '+212 690 459 525',
    phone2: '+212 693 732 139',
    moroccoOffice: 'Bd Dammam, Technopark Casablanca , Maroc .'
  };

  // Services list
  services = [
    { name: 'Sites Web', link: '/services/sites-web' },
    { name: 'Publicité en ligne', link: '/services/publicite' },
    { name: 'Développement d\'Application', link: '/services/developpement' },
    { name: 'Gestion des réseaux sociaux', link: '/services/reseaux-sociaux' },
    { name: 'Design Graphique', link: '/services/design' },
    { name: 'Photographie', link: '/services/photographie' },
    { name: 'Agence SEO', link: '/services/agence-seo' }
  ];

  // Quick links
  quickLinks = [
    { name: 'Accueil', link: '/' },
    { name: 'À propos', link: '/a-propos' },
    { name: 'Contact', link: '/contact' },
    { name: 'Conditions Générales d\'Utilisation', link: '/conditions' },
    { name: 'Politique de Confidentialité', link: '/politique-confidentialite' },
    { name: 'Création site web', link: '/creation-site-web' }
  ];

  // Recent explorations
  recentExplorations = [
    { name: 'Agence de publicité au Maroc', link: '/agence-publicite-maroc' },
    { name: 'Agence de gestion des réseaux sociaux', link: '/gestion-reseaux-sociaux' },
    { name: 'Agence de design graphique', link: '/design-graphique' },
    { name: 'Création site web', link: '/creation-site-web' },
    { name: 'Service de photographie', link: '/photographie' },
    { name: 'Agence de communication', link: '/communication' },
    { name: 'Agence Web', link: '/agence-web' }
  ];

  // FAQ data
  faqs = [
    {
      id: 1,
      question: "Quel est le coût de la création d'un site internet ?",
      answer: "Le coût de la création d'un site internet dépend de plusieurs facteurs, notamment le type de site, les fonctionnalités souhaitées, et la complexité du projet. Chez notre agence de création de sites web au Maroc, nous offrons des solutions adaptées à tous les budgets, de la création de sites vitrines simples à des projets web plus complexes."
    },
    {
      id: 2,
      question: "Quel est le prix d'un site vitrine ?",
      answer: "Un site vitrine professionnel commence à partir de 3500 MAD chez Digital Alchemy. Ce tarif inclut un design responsive, l'optimisation SEO de base, et un accompagnement personnalisé."
    },
    {
      id: 3,
      question: "Quels types de sites web proposez-vous ?",
      answer: "Nous proposons une gamme complète de sites web : sites vitrines, boutiques e-commerce, sites corporate, portfolios, blogs, et applications web sur mesure adaptés à vos besoins spécifiques."
    },
    {
      id: 4,
      question: "Quels sont les avantages d'un site internet responsive ?",
      answer: "Un site responsive s'adapte automatiquement à tous les écrans (mobile, tablette, desktop), améliore l'expérience utilisateur, et est favorisé par Google pour le référencement naturel."
    },
    {
      id: 5,
      question: "Comment puis-je obtenir un nom de domaine pour mon site web ?",
      answer: "Nous vous accompagnons dans le choix et l'enregistrement de votre nom de domaine. Notre équipe vous conseille sur les meilleures extensions (.ma, .com, .fr) selon votre activité."
    },
    {
      id: 6,
      question: "Votre agence digitale offre-t-elle des services de développement web sur mesure ?",
      answer: "Oui, Digital Alchemy développe des solutions web sur mesure adaptées à vos besoins spécifiques : applications métier, plateformes e-commerce avancées, et systèmes de gestion personnalisés."
    },
    {
      id: 7,
      question: "Comment puis-je maximiser la visibilité de mon site web au Maroc ?",
      answer: "Nous optimisons votre site pour le SEO local, créons du contenu de qualité, mettons en place des campagnes Google Ads ciblées, et développons votre présence sur les réseaux sociaux."
    },
    {
      id: 8,
      question: "Pourquoi Choisir Notre Expertise en Création Site Web Maroc ?",
      answer: "Digital Alchemy combine expertise technique, créativité, et connaissance du marché marocain. Nous offrons un support 24/7, des prix compétitifs, et une garantie de satisfaction totale."
    },
    {
      id: 9,
      question: "Quels sont les types de sites proposés en création site web Maroc ?",
      answer: "Nous créons tous types de sites : vitrines professionnels, e-commerce, blogs, portfolios, sites institutionnels, plateformes de réservation, et applications web métier."
    }
  ];

  // Access the form using ViewChild
  @ViewChild('contactForm') contactForm!: NgForm;

  constructor() { }

  ngOnInit(): void {
    // Initialize partners auto-slide
    this.startAutoSlide();
    
    // Any other initialization code
    this.initializeAnimations();
    
    // Initialize portfolio
    this.updateHasMoreProjects();
  }

  ngOnDestroy(): void {
    // Clean up intervals
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  // Initialization methods
  private initializeAnimations(): void {
    // Add any initialization animations or setup here
  }

  // Portfolio Methods
  setActiveFilter(filter: string): void {
    this.activeFilter = filter;
    this.displayedProjectsCount = 6; // Reset to initial count when filter changes
    this.updateHasMoreProjects();
  }

  getFilteredPortfolio(): any[] {
    let filtered = this.activeFilter === 'all' 
      ? this.portfolioItems 
      : this.portfolioItems.filter(item => item.type === this.activeFilter);
    
    return filtered.slice(0, this.displayedProjectsCount);
  }

  loadMoreProjects(): void {
    this.displayedProjectsCount += 6;
    this.updateHasMoreProjects();
  }

  private updateHasMoreProjects(): void {
    const totalFiltered = this.activeFilter === 'all' 
      ? this.portfolioItems.length 
      : this.portfolioItems.filter(item => item.type === this.activeFilter).length;
    
    this.hasMoreProjects = this.displayedProjectsCount < totalFiltered;
  }

  // Portfolio Modal Functions
  openPortfolioModal(portfolio: any): void {
    this.selectedPortfolio = portfolio;
    document.body.style.overflow = 'hidden';
  }

  closePortfolioModal(): void {
    this.selectedPortfolio = null;
    document.body.style.overflow = '';
  }

  // Get preview image URL (small image for grid)
  getPreviewImageUrl(portfolio: any): string {
    if (portfolio && portfolio.image) {
      // Get base name and add 'preview' suffix
      // Example: portfolio/lawoffice -> portfolio/lawofficepreview.webp
      const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
      
      // Handle special cases for naming variations
      if (baseName.includes('cardalia')) {
        return `assets/images/portfolio/cardaliaepreview.webp`;
      }
      if (baseName.includes('Kelpreview') || baseName.includes('Kel')) {
        return `assets/images/portfolio/Kelpreview.webp`;
      }
      if (baseName.includes('Lesagumpreview') || baseName.includes('Lesagum')) {
        return `assets/images/portfolio/Lesagumpreview.webp`;
      }
      if (baseName.includes('clic-lighpreview') || baseName.includes('click-light') || baseName.includes('clic-ligh')) {
        return `assets/images/portfolio/clic-lighpreview.webp`;
      }
      if (baseName.includes('projectpreview') || baseName.includes('project')) {
        return `assets/images/portfolio/projectpreview.webp`;
      }
      
      // If already ends with preview, use as is
      if (baseName.endsWith('preview')) {
        return `assets/images/${baseName}.webp`;
      }
      
      return `assets/images/${baseName}preview.webp`;
    }
    return '';
  }

  // Get full image URL (large image for modal)
  // Falls back to preview image if main image doesn't exist
  getWebpImageUrl(portfolio: any): string {
    if (portfolio && portfolio.image) {
      // Get base name and add .webp extension
      const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
      
      // For projects that only have preview images, use the preview image scaled
      // Check exact image names from portfolio folder
      if (baseName.includes('Kelpreview') || 
          baseName.includes('Lesagumpreview') || 
          baseName.includes('clic-lighpreview') ||
          baseName.includes('projectpreview')) {
        return this.getPreviewImageUrl(portfolio);
      }
      
      // For aimo, check if main image exists (aimo.webp exists)
      if (baseName.includes('aimo') && !baseName.includes('preview')) {
        return `assets/images/${baseName}.webp`;
      }
      
      const mainImageUrl = `assets/images/${baseName}.webp`;
      return mainImageUrl;
    }
    return '';
  }
  
  // Check if project has main image or only preview
  hasMainImage(portfolio: any): boolean {
    if (!portfolio || !portfolio.image) return false;
    const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
    // Projects that only have preview images (exact names from portfolio folder)
    const previewOnlyProjects = ['Kelpreview', 'Lesagumpreview', 'clic-lighpreview', 'projectpreview'];
    // aimo has main image (aimo.webp exists)
    if (baseName.includes('aimo') && !baseName.includes('preview')) {
      return true;
    }
    return !previewOnlyProjects.some(proj => baseName.includes(proj));
  }

  // Handle image error - fallback to preview image
  handleImageError(event: Event, portfolio: any): void {
    const img = event.target as HTMLImageElement;
    if (img && portfolio) {
      img.src = this.getPreviewImageUrl(portfolio);
      img.classList.add('scale-preview');
    }
  }


  // Form navigation methods
  nextStep(): void {
    if (this.validateCurrentStep() && this.currentStep < 3) {
      this.currentStep++;
    }
  }

  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  // FAQ methods
  toggleFaq(faqNumber: number): void {
    if (this.activeFaq === faqNumber) {
      this.activeFaq = null;
    } else {
      this.activeFaq = faqNumber;
    }
  }

  toggleAllFaqs(): void {
    this.showAllFaqs = !this.showAllFaqs;
    // Close any open FAQ when toggling
    this.activeFaq = null;
  }

  // Get FAQ by ID
  getFaqById(id: number) {
    return this.faqs.find(faq => faq.id === id);
  }

  // Partners slider methods
  slidePartners(direction: 'prev' | 'next'): void {
    const track = document.querySelector('.partners-track') as HTMLElement;
    
    if (!track) return;

    if (direction === 'next') {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    } else {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    }
    
    const slideWidth = 280; // Approximate width including margin
    track.style.transform = `translateX(-${this.currentSlide * slideWidth}px)`;
    
    // Reset animation
    track.style.animation = 'none';
    setTimeout(() => {
      track.style.animation = 'slidePartners 30s linear infinite';
    }, 100);
  }

  private startAutoSlide(): void {
    // Auto-advance slides every 5 seconds
    this.autoSlideInterval = setInterval(() => {
      this.slidePartners('next');
    }, 5000);
  }

  pauseAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  resumeAutoSlide(): void {
    this.startAutoSlide();
  }

  // Form validation methods
  isStepValid(step: number): boolean {
    switch (step) {
      case 1:
        return !!(this.formData.name && this.formData.email && this.formData.phone);
      case 2:
        return this.hasSelectedServices();
      case 3:
        return !!(this.formData.subject && this.formData.acceptTerms);
      default:
        return false;
    }
  }

  hasSelectedServices(): boolean {
    return Object.values(this.formData.services).some(service => service);
  }

  // Form validation before each step
  validateCurrentStep(): boolean {
    switch (this.currentStep) {
      case 1:
        if (!this.formData.name.trim()) {
          this.submissionError = 'Le nom est requis.';
          return false;
        }
        if (!this.formData.email.trim() || !this.isValidEmail(this.formData.email)) {
          this.submissionError = 'Une adresse email valide est requise.';
          return false;
        }
        if (!this.formData.phone.trim()) {
          this.submissionError = 'Le numéro de téléphone est requis.';
          return false;
        }
        break;
      
      case 2:
        if (!this.hasSelectedServices()) {
          this.submissionError = 'Veuillez sélectionner au moins un service.';
          return false;
        }
        break;
      
      case 3:
        if (!this.formData.subject.trim()) {
          this.submissionError = 'Le sujet est requis.';
          return false;
        }
        break;
    }
    
    this.submissionError = '';
    return true;
  }

  // Form submission method
  async onSubmit(): Promise<void> {
    if (!this.formData.acceptTerms) {
      this.submissionError = 'Veuillez accepter les conditions générales pour continuer.';
      return;
    }
  
    if (!this.isStepValid(1) || !this.isStepValid(2) || !this.isStepValid(3)) {
      this.submissionError = 'Veuillez remplir tous les champs obligatoires.';
      return;
    }
  
    this.isSubmitting = true;
    this.submissionError = '';
  
    try {
      const result = await this.submitFormData(this.formData);
      
      this.submissionSuccess = true;
      this.formSubmitted = true;
      
      // ✅ AJOUTEZ CE CODE POUR TRACKER LA CONVERSION
      this.trackConversion();
      
      // Show success message for longer
      setTimeout(() => {
        this.resetForm();
      }, 5000);
      
      // Optional: scroll to success message
      setTimeout(() => {
        const successElement = document.querySelector('.success-message');
        if (successElement) {
          successElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
      
    } catch (error) {
      console.error('Form submission error:', error);
      this.submissionError = 'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer ou nous contacter directement.';
    } finally {
      this.isSubmitting = false;
    }
  }

  // Submit form data to Web3Forms
  private async submitFormData(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Create the form data to send
      const formData = new FormData();
      
      // Add your Web3Forms access key (original rhillane key that works)
      formData.append('access_key', 'ed3bd6d3-e198-4b84-b8cf-7b59f9ea2aba'); 
      
      // Add basic form fields
      formData.append('name', data.name || '');
      formData.append('email', data.email || '');
      formData.append('company', data.company || 'Non spécifié');
      formData.append('employeeCount', data.employeeCount || 'Non spécifié');
      formData.append('phone', data.countryCode && data.phone ? `${data.countryCode} ${data.phone}` : (data.phone || 'Non spécifié'));
      formData.append('budget', data.budget || 'Non spécifié');
      formData.append('subject', data.subject || 'Demande de devis');
      formData.append('details', data.details || '');
      
      // Convert selected services to a readable string
      const selectedServices = Object.entries(data.services)
        .filter(([key, value]) => value)
        .map(([key, value]) => {
          // Convert service keys to readable French names
          const serviceNames: { [key: string]: string } = {
            webSite: 'Création de site web',
            seo: 'Référencement SEO',
            advertising: 'Publicité en ligne',
            socialMedia: 'Gestion des réseaux sociaux',
            design: 'Design graphique',
            photo: 'Photographie / Vidéographie',
            copywriting: 'Copywriting',
            global: 'Accompagnement global',
            development: 'Développement d\'application (web/mobile)'
          };
          return serviceNames[key] || key;
        })
        .join(', ');
      
      formData.append('services', selectedServices || 'Aucun service sélectionné');
      
      // Create a comprehensive message
      const comprehensiveMessage = `
NOUVELLE DEMANDE DE DEVIS

=== INFORMATIONS CLIENT ===
Nom: ${data.name}
Email: ${data.email}
Entreprise: ${data.company || 'Non spécifié'}
Nombre d'employés: ${data.employeeCount || 'Non spécifié'}
Téléphone: ${data.countryCode && data.phone ? `${data.countryCode} ${data.phone}` : (data.phone || 'Non spécifié')}

=== SERVICES DEMANDÉS ===
${selectedServices || 'Aucun service sélectionné'}

=== BUDGET ===
${data.budget || 'Non spécifié'}

=== DÉTAILS DU PROJET ===
Sujet: ${data.subject || 'Non spécifié'}

Détails:
${data.details || 'Aucun détail fourni'}

=== INFORMATIONS SUPPLÉMENTAIRES ===
Conditions acceptées: ${data.acceptTerms ? 'Oui' : 'Non'}
Date de soumission: ${new Date().toLocaleString('fr-FR')}
      `.trim();
      
      formData.append('message', comprehensiveMessage);
      
      // Optional: add a custom subject line
      formData.append('subject', `Nouvelle demande de devis de ${data.name} - ${selectedServices.substring(0, 50)}${selectedServices.length > 50 ? '...' : ''}`);
      
      // Send the form using Fetch API
      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erreur réseau');
        }
        return response.json();
      })
      .then(responseData => {
        if (responseData.success) {
          resolve({ 
            success: true, 
            message: 'Demande de devis envoyée avec succès!' 
          });
        } else {
          reject(new Error('Erreur lors de l\'envoi de la demande'));
        }
      })
      .catch(error => {
        console.error('Erreur:', error);
        reject(error);
      });
    });
  }

  // Form reset method
  resetForm(): void {
    if (this.contactForm) {
      this.contactForm.resetForm();
    }

    this.formData = {
      name: '',
      email: '',
      company: '',
      employeeCount: '',
      countryCode: '+33',
      phone: '',
      services: {
        webSite: false,
        seo: false,
        advertising: false,
        socialMedia: false,
        design: false,
        photo: false,
        copywriting: false,
        global: false,
        development: false
      },
      budget: '',
      subject: '',
      details: '',
      acceptTerms: false
    };

    this.currentStep = 1;
    this.formSubmitted = false;
    this.submissionSuccess = false;
    this.submissionError = '';
    this.isSubmitting = false;
  }

  // Footer methods
  changeLanguage(languageCode: string): void {
    // Implement language change logic here
    console.log(`Language changed to: ${languageCode}`);
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openExternalLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  // Utility methods
  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Method to get selected services as an array
  getSelectedServices(): string[] {
    return Object.entries(this.formData.services)
      .filter(([key, value]) => value)
      .map(([key, value]) => key);
  }

  // Method to get services count
  getSelectedServicesCount(): number {
    return this.getSelectedServices().length;
  }

  // Host listener for escape key to close modals/overlays
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    // Close any open FAQ
    this.activeFaq = null;
    
    // Close portfolio modal if open
    if (this.selectedPortfolio) {
      this.closePortfolioModal();
    }
  }

  // Host listener for window resize
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    // Handle responsive behavior if needed
  }

  // Method to handle contact form field changes
  onFieldChange(fieldName: string, value: any): void {
    // Add any custom logic for field changes
    console.log(`Field ${fieldName} changed to:`, value);
  }

  // Method to validate email format
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Method to validate phone number
  isValidPhone(phone: string): boolean {
    const phoneRegex = /^[\d\s\-\+\(\)]+$/;
    return phoneRegex.test(phone) && phone.length >= 8;
  }

  // Method to get form completion percentage
  getFormCompletionPercentage(): number {
    const totalFields = 8; // Adjust based on required fields
    let completedFields = 0;

    if (this.formData.name) completedFields++;
    if (this.formData.email && this.isValidEmail(this.formData.email)) completedFields++;
    if (this.formData.company) completedFields++;
    if (this.formData.phone) completedFields++;
    if (this.hasSelectedServices()) completedFields++;
    if (this.formData.budget) completedFields++;
    if (this.formData.subject) completedFields++;
    if (this.formData.acceptTerms) completedFields++;

    return Math.round((completedFields / totalFields) * 100);
  }

  // Additional footer-specific methods
  navigateToService(serviceLink: string): void {
    // Handle navigation to service pages
    console.log(`Navigating to: ${serviceLink}`);
    // Implement your routing logic here
  }

  navigateToQuickLink(quickLink: string): void {
    // Handle navigation to quick link pages
    console.log(`Navigating to: ${quickLink}`);
    // Implement your routing logic here
  }

  navigateToExploration(explorationLink: string): void {
    // Handle navigation to recent exploration pages
    console.log(`Navigating to: ${explorationLink}`);
    // Implement your routing logic here
  }

    // Method to handle social media clicks
    onSocialLinkClick(platform: string): void {
      const url = this.socialLinks[platform as keyof typeof this.socialLinks];
      if (url) {
        this.openExternalLink(url);
      }
    }

  // Method to handle contact info clicks
  onContactClick(type: 'email' | 'email2' | 'phone1' | 'phone2'): void {
    const contactValue = this.contactInfo[type];
    
    switch (type) {
      case 'email':
      case 'email2':
        window.location.href = `mailto:${contactValue}`;
        break;
      case 'phone1':
      case 'phone2':
        window.location.href = `tel:${contactValue}`;
        break;
    }
  }

  // Method to handle office location clicks
  onOfficeLocationClick(): void {
    const address = this.contactInfo.moroccoOffice;
    
    // Open in Google Maps
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    this.openExternalLink(mapsUrl);
  }

  // Track Google Ads conversion - called ONLY on successful form submission
  private trackConversion(): void {
    try {
      // Check if gtag is available (Google Ads/Analytics)
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('event', 'conversion', {
          'send_to': 'AW-17852668648/XXXXXX', // ⚠️ Replace XXXXXX with your actual conversion label
          'value': 1.0,
          'currency': 'EUR',
          'transaction_id': this.generateTransactionId()
        });
        console.log('Google Ads conversion tracked for rhillane form');
      }
      
      // Alternative: If using Google Tag Manager dataLayer
      if (typeof (window as any).dataLayer !== 'undefined') {
        (window as any).dataLayer.push({
          'event': 'form_submission',
          'formType': 'website_rhillane',
          'formName': 'Demande de devis site web',
          'value': this.formData.budget || 'unknown',
          'services': this.getSelectedServicesString()
        });
        console.log('Google Tag Manager event pushed for rhillane form');
      }
      
    } catch (error) {
      console.error('Error tracking Google conversion:', error);
    }
  }
  
  // Generate a unique transaction ID for each submission
  private generateTransactionId(): string {
    return `lead_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
  
  // Get selected services as a comma-separated string for tracking
  private getSelectedServicesString(): string {
    const selected: string[] = [];
    if (this.formData.services.webSite) selected.push('Site Web');
    if (this.formData.services.seo) selected.push('SEO');
    if (this.formData.services.advertising) selected.push('Publicité');
    if (this.formData.services.socialMedia) selected.push('Réseaux Sociaux');
    if (this.formData.services.design) selected.push('Design');
    if (this.formData.services.photo) selected.push('Photo');
    if (this.formData.services.copywriting) selected.push('Rédaction');
    if (this.formData.services.global) selected.push('Package Global');
    if (this.formData.services.development) selected.push('Développement');
    return selected.join(', ') || 'None';
  }
  
}